import { render, staticRenderFns } from "./SaldoRemessa.vue?vue&type=template&id=3352454a&scoped=true"
import script from "./SaldoRemessa.vue?vue&type=script&lang=js"
export * from "./SaldoRemessa.vue?vue&type=script&lang=js"
import style0 from "./SaldoRemessa.vue?vue&type=style&index=0&id=3352454a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352454a",
  null
  
)

export default component.exports